module.exports = __webpack_public_path__ + "img/ripple-texture.56e7e2a4.jpg";